import React from 'react';
import './ServicePage.css';

const ComplementaryHealth = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>🏥 Tamamlayıcı Sağlık Sigortası</h1>
          <p>SGK'nın karşılamadığı sağlık giderleriniz için</p>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <section className="service-section">
            <h2>Tamamlayıcı Sağlık Sigortası Nedir?</h2>
            <p>
              Tamamlayıcı sağlık sigortası, SGK'nın karşılamadığı sağlık giderlerini 
              karşılayan sigorta türüdür. SGK kapsamındaki tedavileriniz için ek 
              ödeme yapmanız gerektiğinde devreye girer.
            </p>
          </section>

          <section className="service-section">
            <h2>Kapsamı</h2>
            <ul className="service-list">
              <li>SGK katılım payı farkları</li>
              <li>Özel oda farkları</li>
              <li>Ameliyat masrafları</li>
              <li>İlaç giderleri</li>
              <li>Muayene ücretleri</li>
            </ul>
          </section>

          <section className="service-section">
            <h2>Avantajları</h2>
            <ul className="service-list">
              <li>SGK'nın karşılamadığı giderleri karşılar</li>
              <li>Ekonomik sağlık hizmeti</li>
              <li>Geniş hastane ağı</li>
              <li>Hızlı ödeme süreci</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ComplementaryHealth;

